var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Đồng bộ album cũ sang album mới",
        visible: _vm.dialogVisible,
        width: "780px",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "section",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading",
            },
          ],
        },
        [
          _c(
            "div",
            { staticClass: "migration-card" },
            [
              _c("div", { staticClass: "card-sub-title" }, [
                _c("i", { staticClass: "el-icon-s-operation" }),
                _vm._v(" Thông tin đồng bộ\n      "),
              ]),
              _c(
                "el-form",
                {
                  ref: "migrateForm",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.activeRules,
                    "label-position": "top",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Phạm vi đồng bộ", prop: "scope" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: { change: _vm.handleScopeChange },
                          model: {
                            value: _vm.form.scope,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "scope", $$v)
                            },
                            expression: "form.scope",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "school" } }, [
                            _vm._v("Một trường"),
                          ]),
                          _c("el-radio", { attrs: { label: "all" } }, [
                            _vm._v("Tất cả trường"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.scope === "school"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "Trường", prop: "schoolId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "Chọn trường",
                                filterable: "",
                              },
                              model: {
                                value: _vm.form.schoolId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "schoolId", $$v)
                                },
                                expression: "form.schoolId",
                              },
                            },
                            _vm._l(_vm.schoolList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  value: item.id,
                                  label: item.id + " - " + item.schoolName,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "all-school-warning" }, [
                        _c("i", { staticClass: "el-icon-warning-outline" }),
                        _c("span", [
                          _vm._v(
                            "Hệ thống sẽ đồng bộ album của tất cả trường trong khoảng ngày đã chọn."
                          ),
                        ]),
                      ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Từ ngày", prop: "fromDate" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  placeholder: "Chọn ngày bắt đầu",
                                  format: "dd/MM/yyyy",
                                  "value-format": "yyyy-MM-dd",
                                },
                                model: {
                                  value: _vm.form.fromDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "fromDate", $$v)
                                  },
                                  expression: "form.fromDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Đến ngày", prop: "toDate" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  placeholder: "Chọn ngày kết thúc",
                                  format: "dd/MM/yyyy",
                                  "value-format": "yyyy-MM-dd",
                                },
                                model: {
                                  value: _vm.form.toDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "toDate", $$v)
                                  },
                                  expression: "form.toDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "warning-note" }, [
                _c("i", { staticClass: "el-icon-warning-outline" }),
                _c("div", [
                  _c("div", [
                    _vm._v(
                      "Album đã đồng bộ thành công sẽ được bỏ qua, không ghi đè."
                    ),
                  ]),
                  _c("div", [
                    _vm._v(
                      "Album và ảnh đã xoá mềm sẽ được bỏ qua; quan hệ học sinh xoá mềm cũng không được chuyển."
                    ),
                  ]),
                  _vm.form.scope === "all"
                    ? _c("div", [
                        _vm._v(
                          "Album và ảnh chuyển thành công sẽ được đánh dấu để không lấy lại ở lần chạy sau."
                        ),
                      ])
                    : _vm._e(),
                  _c("div", [
                    _vm._v(
                      "Ảnh dùng lại metadata và đường dẫn storage cũ, không copy lại file."
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _vm.result !== null
            ? _c(
                "div",
                { staticClass: "migration-card" },
                [
                  _c("div", { staticClass: "card-sub-title" }, [
                    _c("i", { staticClass: "el-icon-data-analysis" }),
                    _vm._v(" Kết quả đồng bộ\n      "),
                  ]),
                  _c("div", { staticClass: "result-summary" }, [
                    _c("div", { staticClass: "summary-box total" }, [
                      _c("span", { staticClass: "num" }, [
                        _vm._v(_vm._s(_vm.result.totalAlbums)),
                      ]),
                      _c("span", { staticClass: "lbl" }, [
                        _vm._v("Tổng album"),
                      ]),
                    ]),
                    _c("div", { staticClass: "summary-box success" }, [
                      _c("span", { staticClass: "num" }, [
                        _vm._v(_vm._s(_vm.result.importedAlbums)),
                      ]),
                      _c("span", { staticClass: "lbl" }, [
                        _vm._v("Đã đồng bộ ✅"),
                      ]),
                    ]),
                    _c("div", { staticClass: "summary-box skipped" }, [
                      _c("span", { staticClass: "num" }, [
                        _vm._v(_vm._s(_vm.result.skippedAlbums)),
                      ]),
                      _c("span", { staticClass: "lbl" }, [_vm._v("Bỏ qua ⏭️")]),
                    ]),
                    _c("div", { staticClass: "summary-box failed" }, [
                      _c("span", { staticClass: "num" }, [
                        _vm._v(_vm._s(_vm.result.failedAlbums)),
                      ]),
                      _c("span", { staticClass: "lbl" }, [_vm._v("Lỗi ❌")]),
                    ]),
                  ]),
                  _c("div", { staticClass: "result-metrics" }, [
                    _c("div", [
                      _c("span", [_vm._v("Ảnh đã đồng bộ")]),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.result.importedPictures || 0)),
                      ]),
                    ]),
                    _c("div", [
                      _c("span", [_vm._v("Liên kết học sinh đã đồng bộ")]),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.result.importedRelations || 0)),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "result-legend" }, [
                    _c("div", { staticClass: "legend-title" }, [
                      _c("i", { staticClass: "el-icon-info" }),
                      _c("span", [_vm._v("Chú thích")]),
                    ]),
                    _c("div", { staticClass: "legend-item" }, [
                      _c("strong", [_vm._v("Đã đồng bộ:")]),
                      _vm._v(" số album đã được đồng bộ thành công.\n        "),
                    ]),
                    _c("div", { staticClass: "legend-item" }, [
                      _c("strong", [_vm._v("Bỏ qua:")]),
                      _vm._v(
                        " album đã tồn tại hoặc đã được đồng bộ trước đó.\n        "
                      ),
                    ]),
                    _c("div", { staticClass: "legend-item" }, [
                      _c("strong", [_vm._v("Lỗi:")]),
                      _vm._v(
                        " album không thể đồng bộ, xem chi tiết bên dưới để xử lý lại.\n        "
                      ),
                    ]),
                  ]),
                  _vm.result.details && _vm.result.details.length
                    ? _c(
                        "el-collapse",
                        { staticClass: "detail-collapse" },
                        [
                          _c(
                            "el-collapse-item",
                            { attrs: { name: "details" } },
                            [
                              _c("template", { slot: "title" }, [
                                _c("i", { staticClass: "el-icon-tickets" }),
                                _vm._v("  Chi tiết từng album\n          "),
                              ]),
                              _c(
                                "el-table",
                                {
                                  staticClass: "detail-table",
                                  attrs: {
                                    data: _vm.result.details,
                                    border: "",
                                    stripe: "",
                                    "max-height": "280",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "sourceAlbumId",
                                      label: "Id",
                                      width: "100",
                                      align: "center",
                                      "header-align": "center",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Trạng thái",
                                      width: "115",
                                      align: "center",
                                      "header-align": "center",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-tag",
                                                {
                                                  attrs: {
                                                    type: _vm.statusTagType(
                                                      scope.row.status
                                                    ),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.statusLabel(
                                                        scope.row.status
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      367016292
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Ảnh",
                                      width: "92",
                                      align: "center",
                                      "header-align": "center",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row
                                                    .importedPictureCount || 0
                                                ) +
                                                  " / " +
                                                  _vm._s(
                                                    scope.row
                                                      .sourcePictureCount || 0
                                                  )
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4192431582
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Liên kết HS",
                                      width: "112",
                                      align: "center",
                                      "header-align": "center",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row
                                                    .importedRelationCount || 0
                                                ) +
                                                  " / " +
                                                  _vm._s(
                                                    scope.row
                                                      .sourceRelationCount || 0
                                                  )
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      642752862
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "errorMessage",
                                      label: "Ghi chú",
                                      "min-width": "220",
                                      align: "left",
                                      "header-align": "center",
                                      "show-overflow-tooltip": "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: { click: _vm.closeDialog },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _vm._v(" Đóng\n    "),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "medium",
                loading: _vm.isLoading,
              },
              on: { click: _vm.handleMigrate },
            },
            [
              _c("i", { staticClass: "el-icon-refresh" }),
              _vm._v(" Đồng bộ\n    "),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }